import { RootState } from '../store'
export const selectSubDomains = (state: RootState) => state.subDomain.subDomains
export const selectLoading = (state: RootState) => state.subDomain.loading
export const selectError = (state: RootState) => state.subDomain.error
export const selectSubDomain = (state: RootState) => state.subDomain.subDomain
